import { COMPLEX_DOCUMENT_CONTEXT_KEYS } from '../../context/complexDocumentContext';
import {
  TABLE_OF_CONTENTS, CREATIVE_BLOCK, IMAGE_ELEMENT, SVG_ELEMENT, BARCODE_ELEMENT, ELEMENT_TYPES, STATIC_TABLE_BLOCK,
  ACCESSIBLE_ELEMENTS, STATIC_TABLE_ELEMENT, TEXT_BLOCK, DYNAMIC_TABLE_BLOCK,
  LINK_BLOCK,
  BUTTON_BLOCK,
} from '../../utils/complexDocumentConstants';

import HELPER, { autoTransform } from '../../utils/helper';
import { deepCopy } from '../../utils/javascript';
import { checkContrastRatio } from '../../utils/accessibility/colorContrastCheckHelper';
import { processAccessibleTextBlock, constructAccessibleBlock } from './complexDocumentHelper';

const SOCIAL_LINK_ASSETS = {
  FACEBOOK: process.env.REACT_APP_FACEBOOK_IMG_URL,
  LINKEDIN: process.env.REACT_APP_LINKEDIN_IMG_URL,
  INSTAGRAM: process.env.REACT_APP_INSTAGRAM_IMG_URL,
  TWITTER: process.env.REACT_APP_TWITTER_IMG_URL,
  WHATSAPP: process.env.REACT_APP_WHATSAPP_IMG_URL,
};
// Trying an alternative data structure to hold accessibility details
//    {
//      document: {
//        summary: false,
//        totalElements: 0,
//        totalBlocks: 0
//      },
//      flows: ['Page 1', 'Page 2'],
//      'Page 1': {
//        flowUUID: '',
//        background: '',
//        fontSize: '',
//        summaries: [
//          {
//            blockUUID: '',
//          }
//        ],
//        color: {
//          [blockUUID]: [
//            {
//              textColor: '',
//              backgroundColor: '',
//              content: '',
//              fontSize: ''
//            }
//          ]
//        },
//        alternativeText: [
//          {
//            blockUUID: '',
//            elementUUID: '',
//            url: ''
//          }
//        ]
//      },
//      'Page 2': {
//        flowUUID: '',
//        summaries: [],
//        color: [],
//        alternativeText: []
//      }
//    }

const accessibleElements = [BARCODE_ELEMENT, ELEMENT_TYPES.CHART];

export const isElementAccessible = (type) => {
  return accessibleElements.includes(type);
};

function normalizeColor(value) {
  if (!value || value === 'transparent') {
    return '#00000000';
  }
  return value;
}
let nonSummarizedBlocks;

export const getDocumentDetails = ({
  documentContext,
  currentDesign,
  docDesign,
  isEmail = false,
  emailSubject,
  attachments
}) => {
  const accessibilityContext = {
    document: {
      summary: false,
      totalElements: 0,
      totalBlocks: 0
    },
    flows: []
  };
  const documentStyle = {
    fontFamily: documentContext.style.fontFamily,
    fontSize: documentContext.style.fontSize,
  };
  console.log({ documentStyle });
  const documentDesign = {
    name: documentContext[COMPLEX_DOCUMENT_CONTEXT_KEYS.DOCUMENT_NAME],
    documentName: documentContext[COMPLEX_DOCUMENT_CONTEXT_KEYS.DOCUMENT_NAME],
    resourceGroup: documentContext[COMPLEX_DOCUMENT_CONTEXT_KEYS.RESOURCE_GROUP_ID],
    summary: documentContext[COMPLEX_DOCUMENT_CONTEXT_KEYS.DESIGN_SUMMARY],
    style: {
      ...documentContext[COMPLEX_DOCUMENT_CONTEXT_KEYS.STYLES],
      fontFamily: documentStyle.fontFamily,
      fontSize: documentStyle.fontSize,
    },
    subject: emailSubject,
    attachments,
  };
  let hasSummary;
  if(!isEmail)
  {
    hasSummary = documentContext['DESIGN_SUMMARY']?.contents ? documentContext['DESIGN_SUMMARY'].contents.some(item => {
      const content = item.content?.trim();
      return content && content !== '\n';
    }) : false;
  }
  accessibilityContext.document.summary = currentDesign === 'document' ? hasSummary : true;
  const allFlows = documentContext[COMPLEX_DOCUMENT_CONTEXT_KEYS.FLOWS];
  documentDesign.flows = allFlows?.map((existingFlowUUID, index) => {
    const contextFlow = documentContext[existingFlowUUID];
    const flowName = `Page ${index + 1}`;
    nonSummarizedBlocks = 0;
    accessibilityContext.flows.push(flowName);
    accessibilityContext[flowName] = {
      flowUUID: existingFlowUUID,
      background: normalizeColor(contextFlow?.style?.backgroundColor),
      fontSize: contextFlow?.style?.fontSize ?? documentStyle?.fontSize,
      summaries: [],
      color: {},
      alternativeText: []
    };
    const allBlocks = contextFlow.pages.reduce((acc, pageID) => {
      return [
        ...acc,
        ...(contextFlow.header ? [contextFlow.header] : []),
        ...contextFlow[pageID],
        ...(contextFlow.footer ? [contextFlow.footer] : []),
      ];
    }, []); // TODO : Check for TOC flow

    accessibilityContext.document.totalBlocks += allBlocks?.length;
    if (currentDesign === 'document') {
    accessibilityContext.document.summary = documentDesign?.summary?.contents?.length && documentDesign?.summary?.contents[0]?.content !== '\n'
    }
    allBlocks.forEach((blockUUID) => {
      validateBlocks(
        documentContext,
        blockUUID,
        existingFlowUUID,
        flowName,
        accessibilityContext,
        isEmail,
        contextFlow.header
          ? (blockUUID === contextFlow.header)
          : contextFlow.footer
            ? (blockUUID === contextFlow.footer)
            : false
      );
    });

    let documentSummary = [];
    const isTOC = contextFlow?.flowName === TABLE_OF_CONTENTS;
    const documentSummaryBlock = deepCopy(
      documentContext[COMPLEX_DOCUMENT_CONTEXT_KEYS.DESIGN_SUMMARY],
    );
    if (isEmail && currentDesign === 'document' && emailSubject) {
       const processedBlocks = processAccessibleTextBlock(
        emailSubject,
        'documentSummary',
        0,
        true,
        true,
      );
      const parentBlock = Object.assign({}, documentSummaryBlock, {
        blockType: 'parent',
        orderNumber: 1,
        isStandalone: true,
        style: { padding: { left: 20, right: 20, top: 20, bottom: 20 } },
        blockDTOList: processedBlocks,
        blockId: documentContext[COMPLEX_DOCUMENT_CONTEXT_KEYS.DESIGN_SUMMARY_ID],
      });
      delete parentBlock.contents;
      delete parentBlock.uuid;
      documentSummary.push(parentBlock);
    }
    if (documentSummaryBlock.contents) {
      const processedBlocks = processAccessibleTextBlock(
        documentSummaryBlock,
        'documentSummary',
        isTOC,
        emailSubject?.contents[0]?.content !== '\n' ? 1 : 0,
        true,
      );
      const parentBlock = Object.assign({}, documentSummaryBlock, {
        blockType: 'parent',
        orderNumber: emailSubject?.contents[0]?.content !== '\n' ? 1 : 0,
        isStandalone: true,
        style: { padding: { left: 20, right: 20, top: 20, bottom: 20 } },
        blockDTOList: processedBlocks,
        blockId: documentContext[COMPLEX_DOCUMENT_CONTEXT_KEYS.DESIGN_SUMMARY_ID],
      });
      delete parentBlock.contents;
      delete parentBlock.uuid;
      documentSummary.push(parentBlock);
    }
    let orderNumber = documentSummary?.length && index + 1 === 1 ? 1 : 0;

      return {
        orderNumber: index + 1,
        flowName: contextFlow?.flowName,
        style: {
          padding: {
            top: contextFlow.margin[0],
            right: contextFlow.margin[1],
            bottom: contextFlow.margin[2],
            left: contextFlow.margin[3],
          },
          width: contextFlow.width,
          height: contextFlow.height,
          backgroundColor: contextFlow.backgroundColor,
          color: contextFlow.color,
          pageNumber: contextFlow.pageNumber
            ? { ...documentContext[contextFlow.pageNumber] }
            : undefined,
          ...(currentDesign === 'flow' && {
            fontFamily: documentStyle?.fontFamily,
            fontSize: documentStyle?.fontSize,
          }),
        },
        paperSize: contextFlow.size,
        paperOrientation: contextFlow.orientation,
        blocks: allBlocks.reduce((acc, blockUUID, blockIndex) => {
          const isDocSummary = documentSummary.length && index + 1 === 1 && blockIndex === 0;
          const block = documentContext[blockUUID];
          if (block.style?.summary && orderNumber > 1) {
            --orderNumber;
          }
          const [accessibleBlocks, orderNum] = constructAccessibleBlock(
            documentContext,
            blockUUID,
            isTOC,
            orderNumber,
            isDocSummary,
            isEmail
          );
          orderNumber = orderNum;
          return isDocSummary
            ? [...acc, ...documentSummary, ...accessibleBlocks]
            : [...acc, ...accessibleBlocks];
        }, []),
        originalblocks: allBlocks.map(b => {
          const block = deepCopy(documentContext[b]);
          if (block.type === 'static_table') {
            block.contents = block.contents.map(content => {
              content.contents = [documentContext[content.uuid]] || [];
              return content;
            });
          }
          return block;
        }),
      };
    });

    docDesign.current = documentDesign;
    return accessibilityContext;
};

const getColorContrastDetails = (blockDetails, accessibilityContext, blockUUID, flowName, level = 1, documentContext={}) => {
  const blockBg = normalizeColor(blockDetails?.style?.backgroundColor);
  const blockType = blockDetails.blockType;
  if(blockType === "link") return;
  // let blockBg = normalizeColor(blockDetails?.style?.backgroundColor);
  const blockFontSize = blockDetails?.style?.fontSize ?? accessibilityContext[flowName]['fontSize'];
  let blockContents = blockDetails.contents;

  if (blockDetails.blockType === DYNAMIC_TABLE_BLOCK) {
    if (level === 1) {
      blockContents = blockDetails.contents.map(column => Object.assign({}, column.content, { uuid: column.uuid, bg: column.content.style.backgroundColor }));
      // Recursively call method if header is enabled
      getColorContrastDetails(blockDetails, accessibilityContext, blockUUID, flowName, 2, documentContext);
    } else if (level === 2 && blockDetails.style.tableProperties.showHeader) {
      blockContents = blockDetails.contents.map(column => Object.assign({}, column.headerContent, { uuid: column.uuid, bg: column.headerContent.style.backgroundColor }));
      // Recursively call method if groupHeader is enabled
      getColorContrastDetails(blockDetails, accessibilityContext, blockUUID, flowName, 3, documentContext);
    } else if (level === 3 && blockDetails.style.tableProperties.showGroupHeader) {
      blockContents = blockDetails.contents.map(column => Object.assign({}, column.groupHeaderContent, { uuid: column.uuid, bg: column.groupHeaderContent.style.backgroundColor }));
    } else {
      return;
    }
  }

  if(blockDetails.blockType === STATIC_TABLE_BLOCK) {
    blockContents = blockDetails.contents.map(
      column => Object.assign({}, documentContext[column.uuid])
    )
  }

  if (!Array.isArray(blockContents)) return;
  let count = 0;

  blockContents.forEach((contentItem) => { // TODO : Check if these loops are really needed. can we not list the contents by blockType?
    let innerContents = Array.isArray(contentItem?.contents)
      ? contentItem.contents
      : [contentItem];

    innerContents.forEach(inner => {
      const thirdLevelContents = Array.isArray(inner?.contents)
        ? inner.contents
        : [inner];

      thirdLevelContents.forEach(third => {
        const fourthLevelContents = Array.isArray(third?.contents)
          ? third.contents
          : [third];

        fourthLevelContents.forEach(deepItem => {
          let content;
          if(deepItem?.style?.isVariable) {
            const varId = parseInt(deepItem?.content?.replace(/[{}]/g, ''), 10);
            content = documentContext['GLOBAL_VARIABLES'].find(variable => variable.id === varId)?.placeHolderText;  
          } else {
            content = deepItem?.content;
          }
          if (!content || content === '\n') return;
          count++; // TODO : Check if this total count is needed
          const style = deepItem?.style || {};
          const textBg = normalizeColor(style.backgroundColor);
          const textColor = normalizeColor(style.color || '#000000');
          const fontSize = style.fontSize ?? blockFontSize ?? (blockDetails.blockType === 'button' ? 16 : undefined);

          let actualBg = blockBg;
          if (blockType === DYNAMIC_TABLE_BLOCK && contentItem.bg !== undefined) {
            actualBg = contentItem.bg;
          }

          if (blockType === 'button') {
            if (!blockDetails?.style?.linkStyles?.buttonBg?.startsWith('#')) {
              const rgbToHex = (rgb) => '#' + rgb.match(/\d+/g)?.map(x => (+x).toString(16).padStart(2,'0')).join('').toUpperCase();
              actualBg = rgbToHex(blockDetails?.style?.linkStyles?.buttonBg);
            } else {
              actualBg = blockDetails?.style?.linkStyles?.buttonBg;
            }
          }

          if (deepItem.contentType === 'PARAGRAPH') {
            const { fail, bgColor } = checkContrastRatio(Object.assign({}, {
              textColor,
              textBg,
              blockBg: actualBg,
              pageBg: accessibilityContext[flowName]['background']
            }), fontSize);

            if (fail) {
              console.log("textColor :: ", textColor, textBg, blockBg, accessibilityContext[flowName]['background']);
              if (accessibilityContext[flowName].color[blockUUID] === undefined) {
                accessibilityContext[flowName].color = Object.assign({}, accessibilityContext[flowName].color, {
                  [blockUUID]: []
                });
              }
              const words = content ? content.split(/\s+/).filter(Boolean) : [];
              accessibilityContext[flowName].color[blockUUID].push(Object.assign({}, {
                textColor,
                backgroundColor: bgColor,
                content: words.length > 0
                  ? words.slice(0, 3).join(' ')
                  : "ABC",
                fontSize
              }));
            }
          }
        });
      });
    });
  });
}

const validateBlocks = (documentContext, blockUUID, existingFlowUUID, flowName, accessibilityContext, isEmail, isHeaderOrFooter = false) => {
  const newBlock = Object.assign({}, documentContext[blockUUID]);

  let totalElements = 0;

  if (isHeaderOrFooter) {
    // Do nothing (Only summary needed - already added in totalBlocks)
  } if (newBlock.blockType === TEXT_BLOCK) {
    // Do nothing (Text block does not need a summary by default, but requires color contrast - already added in totalBlocks)
  } else if (newBlock.blockType === DYNAMIC_TABLE_BLOCK) {
    if(!isEmail) totalElements += 1;
    if (newBlock.style.tableProperties.showTopBlock) {
      totalElements += 1;
    }
    if (newBlock.style.tableProperties.showBottomBlock) {
      totalElements += 1;
    }
    // TODO : Integrate empty text
  }
  else if (newBlock.blockType === STATIC_TABLE_BLOCK) {
    const accessibleElements = newBlock.contents.filter(el => {
      return documentContext[el.uuid]
        ? ACCESSIBLE_ELEMENTS.includes(documentContext[el.uuid].contentType)
        : false;
    });
    totalElements += accessibleElements.length;
  } else {
    if (!isEmail) {
      const accessibleElements = newBlock.contents?.filter(el => ACCESSIBLE_ELEMENTS.includes(el.contentType));
      if(accessibleElements) {
        totalElements += accessibleElements.reduce((acc, el) => {
          return acc + (el.contentType === STATIC_TABLE_ELEMENT ? 2 : 1);
        }, 0);
      }
    }
  }


  accessibilityContext.document.totalElements += totalElements;

  // 1. Validate summary
  if (!isEmail && newBlock.blockType !== 'text') {
    const hasSummary = newBlock?.style?.summary ? newBlock.style.summary.some(
      item => item.content?.trim() && item.content.trim() !== '\n'
    ) : false;
    if (!hasSummary) {
      accessibilityContext[flowName]['summaries'].push({
        blockUUID
      });
    }
  }

  if (isHeaderOrFooter) {
    console.log("Is a header / footer");
    return;
  }

  // 2. Check color contrast
  // TODO : Check if color contrast is provided correctly for dynamic tables
  if (newBlock.blockType !== CREATIVE_BLOCK) {
    getColorContrastDetails(newBlock, accessibilityContext, blockUUID, flowName, 1, documentContext);
  }
  if (newBlock.blockType === DYNAMIC_TABLE_BLOCK) {
    if (newBlock.style.tableProperties.showTopBlock) {
      const topBlockDetails = Object.assign({}, documentContext[newBlock.style.tableProperties.topBlock]);
      getColorContrastDetails(topBlockDetails, accessibilityContext, newBlock.style.tableProperties.topBlock, flowName, 1, documentContext);
    }
    if (newBlock.style.tableProperties.showBottomBlock) {
      const bottomBlockDetails = Object.assign({}, documentContext[newBlock.style.tableProperties.bottomBlock]);
      getColorContrastDetails(bottomBlockDetails, accessibilityContext, newBlock.style.tableProperties.bottomBlock, flowName, 1, documentContext);
    }
  }
  
  const emailBlockTypes = [BUTTON_BLOCK, DYNAMIC_TABLE_BLOCK, CREATIVE_BLOCK]
  if (isEmail) {
    if (newBlock.blockType == LINK_BLOCK) {
      nonSummarizedBlocks += 1;
      newBlock.contents.forEach(socialElement => {
        if(socialElement.contents[0].content !== "\n") {
          accessibilityContext.document.totalElements += 1;
          const hasSummary =socialElement?.summary ? socialElement.summary.some(
            item => item.content?.trim() && item.content.trim() !== '\n'
          ) : false;
          if (!hasSummary) {
            accessibilityContext[flowName]['alternativeText'].push({
              blockUUID: newBlock.uuid,
              contentType: socialElement.contents[0].contentType,
              url: SOCIAL_LINK_ASSETS[socialElement.contentType],
              bgColor: newBlock.style.backgroundColor,
              socialMediaType: socialElement.contentType
            });
          }
        }
      })
    } else if (emailBlockTypes.includes(newBlock.blockType)) {
      const hasSummary = newBlock?.style?.summary ? newBlock.style.summary.some(
        item => item.content?.trim() && item.content.trim() !== '\n'
      ) : false;
      if (!hasSummary) {
        accessibilityContext[flowName]['summaries'].push({
          blockUUID
        });
      }
    }
    return;
  }

  let imgCount = 0;
  // 3. Check alternative text
  if (newBlock.blockType === CREATIVE_BLOCK) {
    newBlock.contents.forEach(item => {
      if (
        [IMAGE_ELEMENT, SVG_ELEMENT, BARCODE_ELEMENT, ELEMENT_TYPES.CHART].includes(
          item.contentType,
        )
      ) {
        imgCount++;
        const hasSummary = item?.style?.summary ? item.style.summary.some(item => {
          const content = item.content?.trim();
          return content && content !== '\n';
        }) : false;
        if (isElementAccessible(item.contentType) && !hasSummary) {
          accessibilityContext[flowName]['alternativeText'].push({
            blockUUID,
            elementUUID: item.uuid,
            url: getUrl(item)
          });
        }
      }
    });
  } else if (newBlock.blockType === STATIC_TABLE_BLOCK) {
    newBlock.contents.forEach(item => {
      const cellElementsContent = documentContext[item.uuid];
      if (
        [IMAGE_ELEMENT, SVG_ELEMENT, BARCODE_ELEMENT, ELEMENT_TYPES.CHART].includes(
          cellElementsContent?.contentType,
        )
      ) {
        imgCount++;
        const hasSummary = cellElementsContent?.style?.summary ? cellElementsContent.style.summary.some(item => {
          const content = item.content?.trim();
          return content && content !== '\n';
        }) : false;
        if (isElementAccessible(cellElementsContent?.contentType) && !hasSummary) {
          accessibilityContext[flowName]['alternativeText'].push({
            blockUUID,
            elementUUID: cellElementsContent.uuid,
            url: getUrl(cellElementsContent)
          });
        }
      }
    });
  } else if (newBlock.blockType === DYNAMIC_TABLE_BLOCK) {
    const subBlocks = [];
    if (newBlock.style.tableProperties.showTopBlock) {
      subBlocks.push(newBlock.style.tableProperties.topBlock);
    }
    if (newBlock.style.tableProperties.showBottomBlock) {
      subBlocks.push(newBlock.style.tableProperties.bottomBlock);
    }
    subBlocks.forEach(subBlock => {
      const subBlockDetails = documentContext[subBlock];
        subBlockDetails.contents.forEach(item => {
          if (
            [IMAGE_ELEMENT, SVG_ELEMENT, BARCODE_ELEMENT, ELEMENT_TYPES.CHART].includes(
              item.contentType,
            )
          ) {
            imgCount++;
            const hasSummary = item?.style?.summary ? item.style.summary.some(item => {
              const content = item.content?.trim();
              return content && content !== '\n';
            }) : false;
            if (isElementAccessible(item.contentType) && !hasSummary) {
              accessibilityContext[flowName]['alternativeText'].push({
                blockUUID: subBlock,
                elementUUID: item.uuid,
                url: getUrl(item)
              });
            }
          }
        });
    })
  }
};

const getUrl = item => {
  const BASE_URL = HELPER.BASE_URL;
  let newUrl;
  if (item.contentType === 'barcode') {
    newUrl = `${BASE_URL}barcode?type=${item.barcodeType}&text=${encodeURIComponent(
      item.content,
    )}&width=${parseInt(`${item.style.width}`.replaceAll('px', ''), 10)}&height=${parseInt(
      `${item.style.height}`.replaceAll('px', ''),
    )}`;
  } else if (item.contentType === 'image' || item.contentType === 'svg') {
    newUrl = item.url;
  } else if (item.contentType === 'chart') {
    newUrl = item?.contents?.dataUrl;
  }
  return newUrl;
};

export const getAccessibilityPercentage = (accessibilityContext, isEmail = false, emailSubject, currentDesign) => {
  let totalElements = currentDesign === 'document' ? 1 : 0; // hardcoded for document summary
  let percentage = 0;
  let nonAccessibleElements = 0;
  let colorContrastFailures = 0;
  let nonAccessibleBlocks = 0;
  totalElements += isEmail && currentDesign === 'document' ? 1 : 0; //addition for email subject
  totalElements += accessibilityContext.document.totalBlocks;
  totalElements += accessibilityContext.document.totalElements; // TODO : Check for nested elements?

  totalElements -= nonSummarizedBlocks;
  accessibilityContext.flows.forEach(flowName => {
    const flowContext = accessibilityContext[flowName];

    if (flowContext.summaries.length > 0) nonAccessibleBlocks += flowContext.summaries.length;
    if (flowContext.alternativeText.length > 0) nonAccessibleElements += flowContext.alternativeText.length;
    /*if (Object.keys(flowContext.color).length > 0) {
      const totalColorIssues = Object.keys(flowContext.color).reduce((acc, blockUUID) => {
        return acc + flowContext.color[blockUUID].length;
      }, 0);
      colorContrastFailures += totalColorIssues;
    }*/
    if (Object.keys(flowContext.color).length > 0) colorContrastFailures += Object.keys(flowContext.color).length;
  });

  totalElements += colorContrastFailures;
  let failures = (nonAccessibleBlocks + nonAccessibleElements + colorContrastFailures + (accessibilityContext.document.summary ? 0 : 1) + (isEmail && currentDesign === 'document' ? (emailSubject?.contents[0]?.content!=='' && emailSubject?.contents[0]?.content!=='\n' ? 0 : 1) : 0));
  console.log({
    totalElements,
    nonAccessibleElements,
    nonAccessibleBlocks,
    colorContrastFailures,
    failures
  });
  percentage = ((totalElements - failures) / totalElements) * 100;

  return percentage;
}